import { render } from "./ActionMessage.vue?vue&type=template&id=3391bf94"
import script from "./ActionMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionMessage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/ActionMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3391bf94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3391bf94', __exports__)) {
    api.reload('3391bf94', __exports__)
  }
  
  module.hot.accept("./ActionMessage.vue?vue&type=template&id=3391bf94", () => {
    api.rerender('3391bf94', render)
  })

}


export default __exports__